import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useRedeemsUIContext } from "../RedeemsUIContext";

const prepareFilter = (queryParams, values) => {
  const { status, type, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  filter.status = status !== "" ? +status : undefined;
  // Filter by type
  const type1 = type !== "" ? +type : 0;
  // Filter by all fields
  if (searchText) {
    if(type1===0) {
      filter.username = searchText;
    } else if(type1===1) {
      filter.user = searchText;
    } else {
      filter._id = searchText;

    }
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function RedeemsFilter({ listLoading }) {
  // Redeems UI Context
  const redeemsUIContext = useRedeemsUIContext();
  const redeemsUIProps = useMemo(() => {
    return {
      queryParams: redeemsUIContext.queryParams,
      setQueryParams: redeemsUIContext.setQueryParams,
    };
  }, [redeemsUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(redeemsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, redeemsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      redeemsUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          status: "", // values => All=""/Susspended=0/Active=1/Pending=2
          type: "", // values => All=""/Business=0/Individual=1
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by Status"
                  // TODO: Change this code
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="1">Pending</option>
                  <option value="2">Sent</option>
                  <option value="3">Rejected</option>
                  <option value="4">On hold</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Status
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Choose Filter Field"
                  name="type"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("type", e.target.value);
                    handleSubmit();
                  }}
                  value={values.type}
                >
                  <option value="0">Email</option>
                  <option value="1">User ID</option>
                  <option value="2">ID</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Field
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in the specific field
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
